export default "__VITE_ASSET__DeOptrYJ__"